import { useEffect, useRef, useState } from "react";
import { iEnquiry } from "../../interfaces/iEnquiry";
import { ExportMailbox, MAX_EXPORT, exportEnquiriesToExcel } from "../../Logic/Enquiries/ExportToExcel";
import Confirm from "../Generic/ConfirmDialog";
import { ToastDismissOverlay } from "../Generic/ToastDismissOverlay";

interface Props {
    enquiries: iEnquiry[];
    mailboxes: ExportMailbox[];
    onClose: () => void;
}

interface Result {
    type: "info" | "error";
    title: string;
    message: string;
}

export default function ExportEnquiries({ enquiries, mailboxes, onClose }: Props) {
    const [confirmed, setConfirmed] = useState(enquiries.length <= MAX_EXPORT);
    const [result, setResult] = useState<Result>();
    const exported = useRef(false);

    useEffect(() => {
        if (!confirmed || exported.current) return;
        exported.current = true;
        try {
            const { count, fileName } = exportEnquiriesToExcel(enquiries, mailboxes);
            setResult({
                type: "info",
                title: "Export Completed",
                message: `${count} ${count === 1 ? "enquiry" : "enquiries"} exported to ${fileName}.`,
            });
        } catch (error) {
            console.error("Export to Excel failed", error);
            setResult({ type: "error", title: "Export Failed", message: "Export failed." });
        }
    }, [confirmed, enquiries, mailboxes]);

    if (!confirmed) {
        return (
            <Confirm
                title="Warning"
                messageType="warn"
                oKText="Continue"
                onConfirm={() => setConfirmed(true)}
                onCancel={onClose}
            >
                <p>{`Only the first ${MAX_EXPORT} of ${enquiries.length} selected enquiries will be exported.`}</p>
            </Confirm>
        );
    }

    if (!result) return <></>;

    return (
        <ToastDismissOverlay
            type={result.type}
            onDismiss={onClose}
        >
            <div>{result.message}</div>
        </ToastDismissOverlay>
    );
}
